import { IUpdateAtributosComprasUseCase } from "../../../presentation/useCases/update/update_atributos_compras_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateAtributosComprasUseCase
 */

export class UpdateAtributosComprasUseCase implements IUpdateAtributosComprasUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateAtributosCompras(
    exibirDataCadastro: number,
    exibirDataCadastroRequisicao: number,
    exibirDataAprovacaoColetaPreco: number,
    notaCorte: number,
    observacoes: string,
  ): Promise<void> {
    await this.repository.updateAtributosCompras(
      exibirDataCadastro === 1,
      exibirDataCadastroRequisicao === 1,
      exibirDataAprovacaoColetaPreco === 1,
      notaCorte,
      observacoes,
    );
  }
}
